// frontend/src/pages/dashboard/ProjectComponents/ImagePreviewDialog.js
import React, { useState } from 'react';
import { Box, Dialog, DialogContent, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import AttachFileIcon from '@mui/icons-material/AttachFile';

const ImagePreviewDialog = ({ open, onClose, imageUrl, imageName, onDownload }) => {
  const [imageError, setImageError] = useState(false);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          bgcolor: '#000',
          maxWidth: '100%!important',
          p: 3
        }
      }}
    >
      <DialogContent
        fullWidth
        sx={{
          p: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '80vh',
          maxWidth: '100%!important'
        }}
      >
        <Box sx={{ width: '100%', maxWidth: '100%!important' }}>
          {imageError ? (
            <Box sx={{ color: '#fff', textAlign: 'center' }}>
              <AttachFileIcon sx={{ fontSize: 80, mb: 2 }} />
              <Typography>Image failed to load</Typography>
            </Box>
          ) : (
            <img
              src={imageUrl}
              alt={imageName}
              style={{
                width: '100%',
                maxWidth: '100%',
                maxHeight: '80vh',
                objectFit: 'contain'
              }}
              onError={() => setImageError(true)}
            />
          )}
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 2,
              mt: 2
            }}
          >
            <IconButton
              onClick={onClose}
              sx={{
                bgcolor: 'rgba(255,255,255,0.2)',
                color: '#fff',
                zIndex: 10,
                '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' },
              }}
            >
              <CloseIcon />
            </IconButton>
            <IconButton
              onClick={onDownload}
              sx={{
                bgcolor: 'rgba(255,255,255,0.2)',
                color: '#fff',
                zIndex: 10,
                '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' },
              }}
            >
              <DownloadIcon />
            </IconButton>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ImagePreviewDialog;